<template>
    <div>
        <Topheader></Topheader>
        <div class="w1100">
            <div class="title">云台-工作间</div>
            <div class="top-spk">欢迎使用云台媒体服务，请勿抄袭和侵犯他人的成果、不要打扰ta人的生活，尊重网络环境和ta人的隐私，有其他申明请在文字中说明。</div>
        </div>

        <div class="tab-body">
            <div class="w1100 tab-bod">
                <!--<div class="tab-btn" @click="onClickTab(1)">-->
                    <!--<img class="btn-icon"  :src="tabIndex == 1 ? '../../static/icon/zhaopaion.png' : '../../static/icon/zhaopai.png'" alt="">-->
                    <!--<div class="btn-name" :class="tabIndex == 1 ? 'btn-name-a':''">招牌玩家</div>-->
                    <!--<div class="btn-s" :class="tabIndex == 1 ? 'btn-s-a':''"></div>-->
                <!--</div>-->
                <!--<div class="tab-btn"  @click="onClickTab(2)">-->
                    <!--<img class="btn-icon" :src="tabIndex == 2 ? '../../static/icon/jiaodianon.png':'../../static/icon/jiaodian.png'" alt="">-->
                    <!--<div class="btn-name" :class="tabIndex == 2 ? 'btn-name-a':''">焦点时刻</div>-->
                    <!--<div class="btn-s" :class="tabIndex == 2 ? 'btn-s-a':''"></div>-->
                <!--</div>-->
                <div class="tab-btn" @click="onClickTab(3)">
                    <img class="btn-icon" :src="tabIndex == 3 ? '../../static/icon/bowenon.png':'../../static/icon/bowen.png'" alt="">
                    <div class="btn-name" :class="tabIndex == 3 ? 'btn-name-a':''">博文</div>
                    <div class="btn-s" :class="tabIndex == 3 ? 'btn-s-a':''"></div>
                </div>
                <div class="tab-btn" @click="onClickTab(4)">
                    <img class="btn-icon" :src="tabIndex == 4 ? '../../static/icon/jinjion.png':'../../static/icon/jinji.png'" alt="">
                    <div class="btn-name" :class="tabIndex == 4 ? 'btn-name-a':''">竞技比赛</div>
                    <div class="btn-s" :class="tabIndex == 4 ? 'btn-s-a':''"></div>
                </div>
            </div>
        </div>

        <!--内容信息-->
        <div>
            <!--招牌玩家信息-->
            <div v-if="tabIndex==1">

                <div class="c-name">
                    <div class="w1100">
                        <div class="c-input-body">
                            <div class="input-bb">
                                <div class="input-t">发起者</div>
                                <input type="text" v-model="zpData.publish_name" placeholder="例如：Woshuoxia我说下" placeholder-style="color:rgba(161,169,174,1);">
                            </div>
                            <div class="send-btn" @click="onPostZp()">发布</div>
                        </div>
                    </div>
                </div>

                <div class="c-name city-body">
                    <div class="w1100">
                        <div class="c-input-body">
                            <div class="input-bb">
                                <div class="input-t">目的地</div>
                                <input type="text" v-model="zpData.address" class="address" placeholder="请输入目的地" placeholder-style="color:rgba(161,169,174,1);">
                            </div>
                                <div class="cityAll">
                                    <div class="city">
                                        <el-select v-model="zpData.province_id" @change="changeArea1" placeholder="请选择">
                                            <el-option v-for="item in area1List" :key="item.id" :label="item.areaname" :value="item.id">
                                                {{item.areaname}}
                                            </el-option>
                                        </el-select>
                                    </div>
                                    <div class="cityName">省</div>
                                    <div class="city">
                                        <el-select v-model="zpData.city_id" placeholder="请选择">
                                            <el-option v-for="item in area2List" :key="item.id" :label="item.areaname" :value="item.id">
                                                {{item.areaname}}
                                            </el-option>
                                        </el-select>
                                    </div>
                                    <div class="cityName">市</div>
                                </div>
                        </div>
                    </div>
                </div>


                <div class="c-name">
                    <div class="w1100">
                        <div class="c-input-body">

                            <div class="input-bb">
                                <div class="input-t">售&nbsp;&nbsp;&nbsp;价</div>
                                <input type="number" v-model="zpData.price" class="price" placeholder="请输入售价" placeholder-style="color:rgba(161,169,174,1);">
                            </div>

                            <div class="input-bb">
                                <div class="input-t">金额规格</div>
                                <input type="text" v-model="zpData.unit" class="price" placeholder="请输入金额规格 例如每人或者每天等" placeholder-style="color:rgba(161,169,174,1);">
                            </div>

                        </div>
                    </div>
                </div>

                <div class="up-f-img">
                    <el-upload v-if="!imgUrl"
                            class="avatar-uploader"
                            :action="common.uploadUrl()"
                            :show-file-list="false"
                            :before-upload="beforeAvatarUpload"
                            :on-success="handleAvatarSuccess"
                    >
                        <img class="up-img"  @mouseenter="changeImageSrc('../../static/icon/upfmon.png')"
                             @mouseleave="changeImageSrc('../../static/icon/upfm.png')" :src="upfmsrc" alt="">
                    </el-upload>

                    <div v-else class="show-img-div">
                        <el-image class="up-img-show" :src="imgUrl" fit="contain"></el-image>
                        <div class="show-img-btn-body">
                            <!--<img src="../../static/icon/logo.png" alt="">
                            <img src="../../static/icon/logo.png" alt="">-->
                            <img src="../../static/icon/bowendelimg.png" @click="onDelImg(1)" alt="">
                        </div>
                    </div>

                </div>


                <div class="c-name zp-title-body">
                    <div class="w1100">
                        <div class="c-input-body">
                            <div class="input-bb">
                                <div class="input-t">标题</div>
                                <input type="text" v-model="zpData.title" placeholder="请输入招牌玩家标题" placeholder-style="color:rgba(161,169,174,1);">
                            </div>
                        </div>
                    </div>
                </div>

                <div class="hi-zg-body">
                    <div class="w1100">
                        <div class="hi-zg-title">
                            <el-upload
                                       class="avatar-uploader"
                                       :action="common.uploadUrl()"
                                       :show-file-list="false"
                                       :before-upload="beforeAvatarUpload"
                                       :on-success="handleAvatarZps1Success"
                            >
                                <img class="hi-zg-icon" src="../../static/icon/bowenupimg.png" alt="">
                            </el-upload>
                            <div class="hi-zg-text">前置亮点展柜（精彩的商品展架或者高清竖向宣传海报）</div>
                        </div>

                        <div class="hi-zg-img-body">
                            <!--zpImgs1-->
                            <div class="hi-img-b" v-for="(vo,key) in zpImgs1" :key="key">
                                <el-image class="img" :src="vo" fit="cover"></el-image>
                                <div>
                                    <input type="text" placeholder="输入标题" v-model="zpData.imgs1_id[key].img_title" class="ld-input">
                                </div>
                                <div class="hi-del" @click="delZpImg1(key)">删除</div>
                            </div>

                        </div>

                    </div>

                </div>

                <div class="hi-zg-body">
                    <div class="w1100">
                        <div class="hi-zg-title">
                            <el-upload
                                    class="avatar-uploader"
                                    :action="common.uploadUrl()"
                                    :show-file-list="false"
                                    :before-upload="beforeAvatarUpload"
                                    :on-success="handleAvatarZps2Success"
                            >
                                <img class="hi-zg-icon" src="../../static/icon/bowenupimg.png" alt="">
                            </el-upload>
                            <div class="hi-zg-text">上传图集（最多100张）</div>
                        </div>

                        <div class="hi-zg-img-body2">

                            <div class="hi-img-b2" v-for="(vo,key) in zpImgs2" :key="key">
                                <el-image class="img" :src="vo" fit="cover"></el-image>
                                <img class="hi-del-icon" src="../../static/icon/bowendelimg.png" @click="delZpImg2(key)" alt="">
                            </div>

                        </div>

                    </div>

                </div>

                <div class="zp-spk-body">
                    <div class="w1100">
                        <div class="zp-spk-title">招牌介绍说明</div>
                        <textarea v-model="zpData.spk" placeholder="请输入招牌介绍说明"></textarea>
                    </div>
                </div>

                <div class="edit-body">
                    <div class="w1100">
                        <quill-editor
                                v-model="zpData.content"
                                ref="myQuillEditor"
                                :options="editorOption"
                                @blur="onEditorBlur($event)" @focus="onEditorFocus($event)"
                                @change="onEditorChange($event)">
                        </quill-editor>
                    </div>
                </div>

            </div>
            <!--焦点时刻-->
            <div v-else-if="tabIndex == 2">
                <div class="up-f-img">
                    <el-upload v-if="!imgUrlJd"
                               class="avatar-uploader"
                               :action="common.uploadUrl()"
                               :show-file-list="false"
                               :before-upload="beforeAvatarUpload"
                               :on-success="handleAvatarJdSuccess"
                    >
                        <img class="up-img" src="../../static/icon/bowenupimg.png" alt="">
                    </el-upload>

                    <div v-else class="show-img-div">
                        <el-image class="up-img-show" :src="imgUrlJd" fit="contain"></el-image>
                        <div class="show-img-btn-body">
                            <img src="../../static/icon/bowendelimg.png" @click="onDelImg(2)" alt="">
                        </div>
                    </div>

                </div>

                <div class="c-name">
                    <div class="w1100">
                        <div class="c-input-body">
                            <div class="input-bb">
                                <div class="input-t">描述</div>
                                <input type="text" v-model="spkjd" placeholder="一句话描述您的时刻" placeholder-style="color:rgba(161,169,174,1);">
                            </div>
                            <div class="send-btn" @click="onPostJd()">发布</div>
                        </div>
                    </div>
                </div>
                <div style="height: 500px;background-color: #FFF;"></div>

            </div>
            <!--博文信息-->
            <div v-else-if="tabIndex == 3">
                <div class="up-f-img">
                    <el-upload v-if="!imgUrlBw"
                               class="avatar-uploader"
                               :action="common.uploadUrl()"
                               :show-file-list="false"
                               :before-upload="beforeAvatarUpload"
                               :on-success="handleAvatarBwSuccess"
                    >
                        <img class="up-img" src="../../static/icon/bowenupimg.png" alt="">
                    </el-upload>

                    <div v-else class="show-img-div">
                        <el-image class="up-img-show" :src="imgUrlBw" fit="contain"></el-image>
                        <div class="show-img-btn-body">
                            <img src="../../static/icon/bowendelimg.png" @click="onDelImg(4)" alt="">
                        </div>
                    </div>

                </div>
                <div class="c-name">
                    <div class="w1100">
                        <div class="c-input-body">
                            <div class="input-bb">
                                <div class="input-t">标题</div>
                                <input type="text" v-model="titleBw" placeholder="输入博文标题" placeholder-style="color:rgba(161,169,174,1);">
                            </div>
                            <div class="send-btn" @click="onPostBw()">发布</div>
                        </div>
                    </div>
                </div>

                <div class="edit-body">
                    <div class="w1100">
                        <quill-editor
                                v-model="contentBw"
                                ref="myQuillEditor"
                                :options="editorOptionBw"
                                @blur="onEditorBlurBw($event)" @focus="onEditorFocusBw($event)"
                                @change="onEditorChangeBw($event)">
                        </quill-editor>
                    </div>
                </div>

            </div>
            <!--竞技比赛-->
            <div v-else-if="tabIndex == 4">
                <div class="c-name">
                    <div class="w1100">
                        <div class="c-input-body">
                            <div class="input-bb" v-if="athleticsLastInfo.num<=0">
                                <div class="input-t">目前还没有您的上一次预测结果，请开始编辑新的比赛预测。</div>
                            </div>

                            <div v-else class="jj-now-b" @click="$router.push('/cpnList')">
                                <div class="jj-spk">最近一次在{{athleticsLastInfo.last_time}}编辑过一次预测，现在有{{athleticsLastInfo.num}}个预测没有处理结果</div>
                                <div class="jj-now-body">
                                    <div class="jj-now">现在开始处理</div>
                                    <div class="jj-dw-logo" v-for="vo in athleticsLastInfo.dwList">
                                        <el-image class="dw-img" :src="vo.troops1Img_url" fit="cover"></el-image>
                                        <el-image class="dw-img" :src="vo.troops2Img_url" fit="cover"></el-image>
                                    </div>
                                </div>
                            </div>

                            <div class="send-btn" @click="onPostJj()">发布</div>
                        </div>
                    </div>
                </div>

                <div class="up-f-img">
                    <el-upload v-if="!imgUrlJj"
                               class="avatar-uploader"
                               :action="common.uploadUrl()"
                               :show-file-list="false"
                               :before-upload="beforeAvatarUpload"
                               :on-success="handleAvatarJjSuccess"
                    >
                        <img class="up-img" src="../../static/icon/bowenupimg.png" alt="">
                    </el-upload>

                    <div v-else class="show-img-div">
                        <el-image class="up-img-show" :src="imgUrlJj" fit="contain"></el-image>
                        <div class="show-img-btn-body">
                            <img src="../../static/icon/bowendelimg.png" @click="onDelImg(3)" alt="">
                        </div>
                    </div>

                </div>


                    <!--竞技队伍-->
                    <div class="troops-body">
                        <div class="w1100">
                            <div class="jj-dw-logo-body">
                                <div class="troops-list-body">
                                    <div class="troops-left">
                                        <div class="troops-up-body">
                                            <div class="troops-img-name">主场队伍队标</div>

                                            <el-upload
                                                    class="avatar-uploader"
                                                    :action="common.uploadUrl()"
                                                    :show-file-list="false"
                                                    :before-upload="beforeAvatarUpload"
                                                    :on-success="handleAvatarTr1Success"
                                            >
                                                <el-image v-if="!imgUrlTr1" class="troops-up-btn" src="../../static/icon/bowenupimg.png" fit="contain"></el-image>
                                                <el-image v-else class="troops-up-btn" :src="imgUrlTr1" fit="contain"></el-image>
                                            </el-upload>
                                        </div>
                                        <div class="troops-title-body">
                                            <div class="troops-img-name">队伍名称</div>
                                            <input class="sd-input" v-model="jjData.troops1_name" type="text" placeholder="请输入队伍名称" placeholder-style="color:rgba(161,169,174,1);">
                                        </div>
                                    </div>
                                </div>
                                <div class="troops-list-body">
                                    <div class="troops-left">
                                        <div class="troops-up-body">
                                            <div class="troops-img-name">客场队伍队标</div>

                                            <el-upload
                                                    class="avatar-uploader"
                                                    :action="common.uploadUrl()"
                                                    :show-file-list="false"
                                                    :before-upload="beforeAvatarUpload"
                                                    :on-success="handleAvatarTr2Success"
                                            >
                                                <el-image v-if="!imgUrlTr2" class="troops-up-btn" src="../../static/icon/bowenupimg.png" fit="contain"></el-image>
                                                <el-image v-else class="troops-up-btn" :src="imgUrlTr2" fit="contain"></el-image>
                                            </el-upload>
                                        </div>
                                        <div class="troops-title-body">
                                            <div class="troops-img-name">队伍名称</div>
                                            <input class="sd-input" v-model="jjData.troops2_name" type="text" placeholder="请输入队伍名称" placeholder-style="color:rgba(161,169,174,1);">
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>


                <div class="c-name zp-title-body" style="border-bottom: none;">
                    <div class="w1100">

                        <div class="c-input-body">
                            <div class="input-bb">
                                <div class="input-t" style="width: 100px;">比赛时间</div>
                                <el-date-picker class="time-select"
                                        v-model="jjData.bs_time"
                                        type="datetime"
                                        placeholder="选择比赛时间"
                                        align="right"
                                        value-format="yyyy-MM-dd HH:mm:ss"
                                        :picker-options="pickerOptions">
                                </el-date-picker>
                            </div>

                        </div>

                    </div>
                </div>

                <div class="c-name zp-title-body" style="border-bottom: none;">
                    <div class="w1100">
                        <div class="c-input-body">
                            <div class="input-bb">
                                <div class="input-t" style="width: 100px;">赛事名称</div>
                                <input type="text" v-model="jjData.title" placeholder="请填写赛事名，名称请勿写的过多" placeholder-style="color:rgba(161,169,174,1);">
                            </div>
                        </div>
                    </div>
                </div>


                <div class="c-name zp-title-body" style="border-bottom: none;">
                    <div class="w1100">
                        <div class="c-input-body">
                            <div class="input-bb">
                                <div class="input-t" style="width: 100px;">预测选项说明</div>
                                <input type="text" v-model="jjData.spk" placeholder="请填写预测选项，请勿写的过多" placeholder-style="color:rgba(161,169,174,1);">
                            </div>
                        </div>
                    </div>
                </div>

                <div class="zp-spk-body">
                    <div class="w1100">
                        <div class="zp-spk-title">推荐理由</div>
                        <textarea v-model="jjData.reason" placeholder="请输入推荐理由。"></textarea>
                    </div>
                </div>

            </div>
        </div>

    </div>

</template>

<script>
    import Topheader from "../components/header"; //上传图片
    import { quillEditor } from 'vue-quill-editor'
    export default {
        components: {
            Topheader
        },
        name: "cloud",
        mounted() {
            document
                .querySelector("body")
                .setAttribute("style", "background-color:#ECECEC");
        },
        data() {
            return {
                upfmsrc:'../../static/icon/upfm.png',
                postZp:true,//提交招牌
                postJd:true,//提交焦点
                postBw:true,//提交博文
                postJj:true,//提交竞技
                tabIndex: 3,
                area1List:[],//省列表
                area2List:[],//市列表,
                city_id:null,
                province_id:null,
                imgUrl:null,
                imgUrlJd:null,//焦点时刻
                imgsjd_id:'',//焦点时刻
                spkjd:'',//焦点时刻
                imgUrlBw:null,//博文
                imgsbw_id:'',//博文
                titleBw:'',//博文
                contentBw:'',//博文
                imgUrlJj:null,//竞技比赛
                content:'',
                editorOption:{
                    /*modules:{
                        toolbar:[
                            ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
                            ['blockquote', 'code-block']
                        ]
                    },*/
                    placeholder:'玩家规则'
                },
                editorOptionBw:{
                    /*modules:{
                        toolbar:[
                            ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
                            ['blockquote', 'code-block']
                        ]
                    },*/
                    placeholder:'博文信息'
                },
                sdList:[],
                sdIndex:0,//赛段选择
                pickerOptions: {
                    shortcuts: [{
                        text: '今天',
                        onClick(picker) {
                            picker.$emit('pick', new Date());
                        }
                    }, {
                        text: '明天',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() + 3600 * 1000 * 24);
                            picker.$emit('pick', date);
                        }
                    }, {
                        text: '昨天',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24);
                            picker.$emit('pick', date);
                        }
                    }, {
                        text: '三天后',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() + 3600 * 1000 * 24 * 3);
                            picker.$emit('pick', date);
                        }
                    }, {
                        text: '一周前',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', date);
                        }
                    }]
                },
                bsTime:'',//比赛时间
                trIndex1:null,//队伍1胜输单选
                trIndex2:null,//队伍2胜输单选
                imgUrlTr1:null,//队标1
                imgUrlTr2:null,//队标2
                zpImgs1:[],
                zpImgs2:[],
                zpData:{
                    publish_name:'',
                    address:'',
                    province_id:'',
                    city_id:'',
                    price:'',
                    unit:'',
                    img_id:'',
                    title:'',
                    imgs1_id:[],
                    imgs2_id:[],
                    spk:'',
                    content:'',
                },
                jjData:{
                    img_id:'',
                    troops1_img_id:'',
                    troops1_name:'',
                    troops1_score:'',
                    troops1_type:'',
                    troops2_img_id:'',
                    troops2_name:'',
                    troops2_score:'',
                    troops2_type:'',
                    type:'',
                    spk:'',
                    title:'',
                    reason:'',
                    bs_time:'',
                    zhou:'',
                    lun:'',
                },
                athleticsLastInfo:{},//竞技比赛上次信息
            };
        },
        created() {
            this.getAreaList();//获取省
            this.getTypeList();//获取类型
            this.getAthleticsLast();
            let tabIndex=localStorage.getItem('cloudTab');
            if(tabIndex){
                this.tabIndex =tabIndex;
            }
        },
        computed: {
            editor() {
                return this.$refs.myQuillEditor.quill;
            },
        }
        ,
        //方法定义
        methods: {
            //请求竞技上次信息
            getAthleticsLast(){
              let _this=this;
              _this.common.request('api/athletics/lastUp',{},function (res) {
                  if(res.status == 200){
                      _this.athleticsLastInfo=res.data;
                  }
              })
            },
            changeImageSrc(src){
              let _this=this;
              _this.upfmsrc=src;
            },
            //发布竞技比赛
            onPostJj(){
              let _this=this;
                if(!_this.postJj){
                    _this.common.vMessage('数据正在上传中，请勿重复提交，请耐心等待','warning');
                    return;
                }
                _this.postJj=false;
              let data=_this.jjData;
                _this.common.request('api/dynamic/addJj',data,function (res) {
                    _this.postJj=true;
                    if (res.status == 200) {
                        _this.$message({
                            message: res.message,
                            type: "success",
                            duration: 1500,
                            center: true,
                            onClose: function(res) {
                                _this.$router.go(-1);
                            }
                        });
                    }
                },'post')
            },
            //发布招牌信息
            onPostZp(){
              let _this=this;
              if(!_this.postZp){
                  _this.common.vMessage('数据正在上传中，请勿重复提交，请耐心等待','warning');
                  return;
              }
              _this.postZp=false;
              let data=_this.zpData;
                 data.imgs1_id=JSON.stringify(data.imgs1_id);
                _this.common.request('api/dynamic/addZpwj',data,function (res) {
                    _this.postZp=true;
                    if (res.status == 200) {
                        _this.$message({
                            message: res.message,
                            type: "success",
                            duration: 1500,
                            center: true,
                            onClose: function(res) {
                                _this.$router.go(-1);
                            }
                        });
                    }
                },'post')
            },
            //发布博文信息
            onPostBw(){
                let _this=this;
                if(!_this.postBw){
                    _this.common.vMessage('数据正在上传中，请勿重复提交，请耐心等待','warning');
                    return;
                }
                _this.postBw=false;
                let data={
                    title:_this.titleBw,
                    content:_this.contentBw,
                    imgs_id:_this.imgsbw_id,
                };
                _this.common.request('api/dynamic/addBw',data,function (res) {
                    _this.postBw=true;
                    if (res.status == 200) {
                        _this.$message({
                            message: res.message,
                            type: "success",
                            duration: 1500,
                            center: true,
                            onClose: function(res) {
                                _this.$router.go(-1);
                            }
                        });
                    }
                },'post')
            },
            //获取赛段类型
            getTypeList(){
              let _this=this;
              _this.common.request('api/athletics/typeList',{},function (res) {
                  if(res.status == 200){
                      _this.sdList=res.data;
                  }
              })
            },
            //发布焦点时刻
            onPostJd(){
                let _this=this;
                if(!_this.postJd){
                    _this.common.vMessage('数据正在上传中，请勿重复提交，请耐心等待','warning');
                    return;
                }
                _this.postJd=false;
                let data={
                    imgs_id:_this.imgsjd_id,
                    spk:_this.spkjd
                };
                _this.common.request('api/dynamic/addJd',data,function (res) {
                    _this.postJd=true;
                    if (res.status == 200) {
                        _this.$message({
                            message: res.message,
                            type: "success",
                            duration: 1500,
                            center: true,
                            onClose: function(res) {
                                _this.$router.go(-1);
                            }
                        });
                    }
                },'post')
            },
            //点击分数
            clickTr(obj,type){
              if(obj==1){
                  this.trIndex1=type;
                  this.jjData.troops1_type=type;
              }else{
                  this.trIndex2=type;
                  this.jjData.troops2_type=type;
              }
            },
            checkSd(key){
                this.sdIndex=key;
                this.jjData.type=this.sdList[key].id;
            },
            onClickTab(index){
                this.tabIndex =index;
                localStorage.setItem('cloudTab',index);
            },
            //获取省市
            getAreaList(pid){
                let _this=this;
                pid = pid || null;
                _this.common.request('api/area',{pid:pid},function (res) {
                    if(res.status == 200){
                        if(pid){
                            _this.area2List=res.data.list;
                        }else {
                            _this.area1List=res.data.list;
                        }
                    }
                })
            },
            //切换省
            changeArea1(e){
                this.getAreaList(e);
                this.zpData.city_id=null;
            },
            //招牌玩具上传图片
            handleAvatarSuccess(res, file) {
                this.zpData.img_id = res.data.id;
                this.imgUrl = URL.createObjectURL(file.raw);
            },
            handleAvatarZps1Success(res, file) {
                this.zpData.imgs1_id.push({img_id:res.data.id,img_title:''});
                this.zpImgs1.push(URL.createObjectURL(file.raw));
            },
            handleAvatarZps2Success(res, file) {
                this.zpData.imgs2_id.push(res.data.id);
                this.zpImgs2.push(URL.createObjectURL(file.raw));
            },
            beforeAvatarUpload(res, file){

            },
            //上传图片(焦点时刻)
            handleAvatarJdSuccess(res, file) {
                this.imgsjd_id = res.data.id;
                this.imgUrlJd = URL.createObjectURL(file.raw);
            },
            //上传图片(博文)
            handleAvatarBwSuccess(res, file) {
                this.imgsbw_id = res.data.id;
                this.imgUrlBw = URL.createObjectURL(file.raw);
            },
            //上传图片(竞技比赛)
            handleAvatarJjSuccess(res, file) {
                this.jjData.img_id = res.data.id;
                this.imgUrlJj = URL.createObjectURL(file.raw);
            },
            handleAvatarTr1Success(res, file) {
                this.jjData.troops1_img_id = res.data.id;
                this.imgUrlTr1 = URL.createObjectURL(file.raw);
            },
            handleAvatarTr2Success(res, file) {
                this.jjData.troops2_img_id = res.data.id;
                this.imgUrlTr2 = URL.createObjectURL(file.raw);
            },
            onDelImg(type){
                if(type == 1){
                    this.zpData.img_id='';
                    this.imgUrl=null;
                }else if(type == 2){
                    this.imgUrlJd=null;
                    this.imgsjd_id='';
                }else if(type == 3){
                    this.jjData.img_id='';
                    this.imgUrlJj=null;
                }else if(type == 4){
                    this.imgUrlBw=null;
                    this.imgsbw_id='';
                }
            },
            onEditorBlur(){//失去焦点事件
            },
            onEditorFocus(){//获得焦点事件
            },
            onEditorChange(){//内容改变事件
                //console.log(this.content)
                //$('.text').html(this.content)
            },
            onEditorBlurBw(){//失去焦点事件
            },
            onEditorFocusBw(){//获得焦点事件
            },
            onEditorChangeBw(){//内容改变事件
                //console.log(this.content)
                //$('.text').html(this.content)
            },
            delZpImg1(key){
                this.zpImgs1.splice(key,1);
                this.zpData.imgs1_id.splice(key,1);
            },
            delZpImg2(key){
                this.zpImgs2.splice(key,1);
                this.zpData.imgs2_id.splice(key,1);
            }
        }
    }
</script>

<style scoped lang='less' rel="stylesheet/less">
    @import "../assets/css/index.less";

    .title{
        font-size:24px;
        font-family:PingFang SC;
        font-weight:800;
        color:rgba(72,72,72,1);
        margin-top: 10px;
    }
    .top-spk{
        font-size:16px;
        font-family:PingFang SC;
        font-weight:500;
        color:rgba(155,155,155,1);
    }
    .tab-body{
        height:70px;
        background:rgba(225,225,225,1);
        margin-top: 20px;
    }
    .tab-bod{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        height: 100%;
    }
    .tab-btn{
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin-right: 60px;
        cursor: pointer;
    }
    .btn-icon{
        width:36px;
        height:36px;
    }
    .btn-name{
        font-size:18px;
        font-family:PingFang SC;
        font-weight:500;
        color:rgba(43,111,158,1);
        margin-left: 10px;
    }
    .btn-name-a{
        color: #549DCF;
        font-weight: bold;
    }
    .btn-s{
        width:8px;
        height:8px;
        border-radius:50%;
        margin-left: 8px;
        background:rgba(225,225,225,1);
    }
    .btn-s-a{
        background:rgba(84,157,207,1);
    }

    .c-name{
        height:68px;
        background:rgba(255,255,255,1);
    }
    .c-input-body{
        height: 68px;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .c-input-body input{
        height: 100%;
        font-family:Microsoft YaHei;
        width: 600px;
        margin-left: 20px;
    }
    .send-btn{
        width:78px;
        height:40px;
        background:rgba(57,160,233,1);
        border-radius:8px;
        font-family:Microsoft YaHei;
        color:#FFFFFF;
        line-height:40px;
        text-align: center;
        cursor: pointer;
    }
    .send-btn:hover{
        background:rgba(57,160,233,0.5);
    }
    .input-t{
        font-family:Microsoft YaHei;
        color:rgba(161,169,174,1);
    }

    .input-bb{
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }

    .cityAll{
        .flexStart;
        .cityName{
            color: #353535;
            font-size: 15px;
            margin: 0 15px;
        }
    }

    .c-input-body .address{
        width: 470px;
    }

    .c-input-body .price{
        width: 400px;
    }

    .city-body{
        margin: 6px 0;
    }
    .up-f-img{
        height:498px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .up-img{
        width:274px;
        height:176px;
    }
    .show-img-div{
        width: 100%;
        height: 100%;
        position: relative;
    }
    .up-img-show{
        width: 100%;
        height: 100%;
    }
    .show-img-btn-body{
        position: absolute;
        width: 100%;
        height: 80px;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }
    .show-img-btn-body img{
        width:58px;
        height:58px;
        border-radius: 50%;
        margin-left: 20px;
        cursor: pointer;
    }
    .zp-title-body{
        border-bottom: 1px solid #ECECEC;
    }
    .hi-zg-body{
        min-height:452px;
        background:rgba(255,255,255,1);
        border-bottom: 1px solid #ECECEC;
        padding: 20px 0;
    }
    .hi-zg-title{
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .hi-zg-icon{
        width:43px;
        height:43px;
    }
    .hi-zg-text{
        font-family:Microsoft YaHei;
        color:rgba(161,169,174,1);
        margin-left: 20px;
    }
    .hi-zg-img-body{
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        margin-top: 20px;

    }
    .hi-img-b{
        margin-right: 10px;
    }
    .hi-img-b .img{
        width:210px;
        height:286px;
    }
    .hi-del{
        font-family:Microsoft YaHei;
        color:rgba(155,155,155,1);
        text-align: center;
        cursor: pointer;
        height: 30px;
        line-height: 30px;
    }
    .hi-zg-img-body2{
        display: flex;
        flex-wrap: wrap;
        margin-top: 10px;
    }
    .hi-img-b2{
        position: relative;
        margin-right: 10px;

    }
    .hi-img-b2 .img{
        height:242px;
    }
    .hi-img-b2 .hi-del-icon{
        position: absolute;
        width:38px;
        height:38px;
        border-radius: 50%;
        right: 20px;
        top: 20px;
        cursor: pointer;
    }
    .zp-spk-body{
        height:228px;
        background:rgba(255,255,255,1);
        padding: 20px 0 ;
    }
    .zp-spk-title{
        font-family:Microsoft YaHei;
        color:rgba(161,169,174,1);
    }

    textarea{
        color: #333;
        font-size: 14px;
        outline: none;
        border: none;
        width: 98%;
        resize: none;
        height: 200px
    }
    .edit-body{
        background-color: #FFF;
        height: 880px;
    }
    .quill-editor{
        height:800px;
    }
    .radio-bodys{
        background-color: #FFF;
        padding: 20px 0;
    }
    .radio-body{
        display: flex;
        justify-content: flex-start;

    }
    .radio-left{
        font-family:Microsoft YaHei;
        font-weight:400;
        color:rgba(147,155,160,1);
        width: 90px;
        line-height: 40px;
    }
    .radio-right{
        display: flex;
        flex-wrap: wrap;
    }
    .radio-list{
        margin-right: 50px;
        font-family:Microsoft YaHei;
        color:rgba(161,169,174,1);
        cursor: pointer;
        line-height: 40px;
    }
    .radio-list-a{
        color: #484848;
        font-weight: bold;
    }
    .time-select{
        margin-left: 20px;
    }

    .c-input-body .sd-input{
        width: 200px;
    }
    .troops-body{
        background-color: #FFF;
        padding: 20px 0;
    }
    .troops-list-body{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .troops-left{
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .troops-up-body{
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .troops-img-name{
        font-family:Microsoft YaHei;
        color:rgba(147,155,160,1);
        margin-right: 20px;
    }
    .troops-up-btn{
        width:88px;
        height:88px;
    }
    .troops-title-body{
        margin-left: 20px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .troops-title-body .sd-input{
        width: 200px;
    }
    .troops-radio-body{
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .troops-right{
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .tr-r{
        width:86px;
        height:48px;
        font-size:24px;
        font-family:Microsoft YaHei;
        font-weight:bold;
        color:rgba(72,72,72,1);
        margin-left: 40px;
        cursor: pointer;
        text-align: center;
        line-height: 48px;
    }
    .tr-r-a{
        background:rgba(212,214,56,1);
        border-radius:12px;
        color: #FFFFFF;
    }
    .troop-c-body-t{
        background-color: #FFF;
    }
    .troop-c-body{
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size:16px;
        font-family:Microsoft YaHei;
        font-weight:400;
        color:rgba(147,155,160,1);
        background-color: #FFF;
    }
    .tr-c-right{
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .tr-c-left,.tr-c-right{
        width: 50%;
    }
    .tr-c2{
        margin-left: 260px;
    }
    .jj-now-b{
        cursor: pointer;
    }
    .jj-spk{
        font-size:14px;
        font-family:PingFang SC;
        font-weight:500;
        color:rgba(72,72,72,1);
    }
    .jj-now-body{
        display: flex;
        justify-content: flex-start;
        margin-top: 8px;
    }
    .jj-now{
        font-size:18px;
        font-family:PingFang SC;
        font-weight:bold;
        color:rgba(84,157,207,1);
    }
    .jj-dw-logo{
        margin-left: 20px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .dw-img{
        width:28px;
        height:20px;
        margin-right: 10px;
    }

    .ld-input{
        height:26px;
        font-family:Microsoft YaHei;
        font-weight:bold;
        color:rgba(72,72,72,1);
        text-align: center;
    }
    .jj-dw-logo-body{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .el-input--suffix .el-input__inner,.el-input--prefix .el-input__inner,.el-input__inner{
        border: none!important;
    }

</style>


// WEBPACK FOOTER //
// src/view/cloud.vue